import { gql } from '@grandvisionhq/graphql';

const contactLensSubscriptionTypeDetails = gql`
  fragment ContactLensSubscriptionTypeDetailsFragment on ContactLensSubscriptionTypeDetails {
    billingFrequency
    deliveryFrequency
    prescriptionForSubscription {
      leftLens {
        axis
        baseCurve
        cylinder
        diameter
        power
      }
      rightLens {
        axis
        baseCurve
        cylinder
        diameter
        power
      }
    }
    subscriptionPromotion {
      code
      localizedTexts {
        locale
        value
      }
    }
  }
`;

export { contactLensSubscriptionTypeDetails };
//# sourceMappingURL=contact-lens-subscription.js.map
